import { render, staticRenderFns } from "./importInstitution.vue?vue&type=template&id=808a2c56&scoped=true"
import script from "./importInstitution.vue?vue&type=script&lang=js"
export * from "./importInstitution.vue?vue&type=script&lang=js"
import style0 from "./importInstitution.vue?vue&type=style&index=0&id=808a2c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808a2c56",
  null
  
)

export default component.exports